export default __webpack_public_path__ + "static/media/golf.15deee41.png";